var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataUsage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0832 2.22083V5.50333C17.7557 6.03416 20.5832 9.17583 20.5832 13C20.5832 13.975 20.3882 14.8958 20.0632 15.7517L22.8798 17.4092C23.4865 16.0658 23.8332 14.5708 23.8332 13C23.8332 7.38833 19.554 2.76249 14.0832 2.22083ZM12.9998 20.5833C8.80734 20.5833 5.4165 17.1925 5.4165 13C5.4165 9.17583 8.244 6.03416 11.9165 5.50333V2.22083C6.43484 2.76249 2.1665 7.37749 2.1665 13C2.1665 18.98 7.009 23.8333 12.989 23.8333C16.5748 23.8333 19.749 22.0892 21.7207 19.4025L18.904 17.745C18.1973 18.6323 17.2992 19.3485 16.2768 19.8399C15.2544 20.3314 14.1342 20.5856 12.9998 20.5833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataUsage);
export default __webpack_public_path__ + "static/media/data-usage.596af23eb528cf721254bacdf16b382a.svg";
export { ForwardRef as ReactComponent };